import React from 'react';
import './Projects.css';
import { useLanguage } from './Contexts/LanguageContext';  // Importeer de hook voor de taal

// Importeer de SVG-bestanden voor social media iconen
import FacebookIcon from './assets/icons/facebook.svg';
import InstagramIcon from './assets/icons/instagram.svg';
import LinkedInIcon from './assets/icons/linkedin.svg';

function Projects() {
    const { language } = useLanguage();  // Verkrijg de huidige taal

    return (
        <div className="projects-container">
            {/* De "My Projects" tekst verandert afhankelijk van de taal */}
            <div className="projects-header">
                <h2>{language === 'nl' ? 'Mijn Projecten' : 'My Projects'}</h2>
            </div>

            {/* Project cards */}
            <div className="projects-grid">
                <div className="project-card">
                    <h3>{language === 'nl' ? 'Project 1' : 'Project 1'}</h3>
                    <p>{language === 'nl' ? 'Beschrijving van project 1.' : 'Description of project 1.'}</p>
                </div>
                <div className="project-card">
                    <h3>{language === 'nl' ? 'Project 2' : 'Project 2'}</h3>
                    <p>{language === 'nl' ? 'Beschrijving van project 2.' : 'Description of project 2.'}</p>
                </div>
                <div className="project-card">
                    <h3>{language === 'nl' ? 'Project 3' : 'Project 3'}</h3>
                    <p>{language === 'nl' ? 'Beschrijving van project 3.' : 'Description of project 3.'}</p>
                </div>
            </div>

            {/* Social media iconen */}
            <div className="social-icons">
                <a href="https://www.facebook.com/valentino.dossantos.7" target="_blank" rel="noopener noreferrer">
                    <img src={FacebookIcon} alt="Facebook" className="social-icon" />
                </a>
                <a href="https://www.instagram.com/mightylion23" target="_blank" rel="noopener noreferrer">
                    <img src={InstagramIcon} alt="Instagram" className="social-icon" />
                </a>
                <a href="https://www.linkedin.com/in/valentino-dos-santos-52044b234/" target="_blank" rel="noopener noreferrer">
                    <img src={LinkedInIcon} alt="LinkedIn" className="social-icon" />
                </a>
            </div>
        </div>
    );
}

export default Projects;
